export const CLAROPAGOS_GATE = 'claropagosgate';
export const CHECKOUT = 'checkout';
export const AUTH_CLIENT = 'tokens.create_client.header.authorization';
export const AUTH_CARD = 'tokens.create_card.header.authorization';
export const RESP_DATA = 'data.data';
export const RESP_CODE_ERROR = 'response.data.error.code';
export const RESP_MSG_ERROR = 'response.data.error.message';

export const RESP_OBJECT_TYPE = 'entry.object_type';
export const SUSCRIPTION_TYPE = 'A';
export const GATE_LIST = 'response.list';
export const BUYLINK_LIST = 'response.workflow.listBuyLinks';
export const WFS_ACCOUNT = 'paymentMethodData.account';
export const CP_CLIENT_ID = 'cliente.id';
export const WFS_ACCOUNT_TOKEN = 'paymentMethodData.cardsData.0.token';
export const WFS_CARD_TYPE = 'paymentMethodData.cardsData.0.card_type';
export const WFS_CARD_NUMBER = 'paymentMethodData.cardsData.0.pan';
export const CP_CARD_TOKEN = 'creditCardModel.tarjeta.token';

export const FINGER_PRINT = 'payments.cybersource.fingerprint';
export const CP_CONFIG = 'metadata.claropagos_configuration';
export const CP_CONFIG_UPDATE_HEADER =
  'request.update_card.header.authorization';
export const CP_CONFIG_DELETE_CARD_HEADER= 'request.delete_card.header.authorization'
export const LINK_WFS = 'payway.currentPayment.currentPBI.linkworkflowstart';
export const OFFER_ID = 'payway.currentPayment.currentPBI.offerid';
export const BUY_TOKEN = 'payway.currentPayment.currentWFS.buyToken';
export const CP_ACCOUNT =
  'payway.currentPayment.currentWFS.paymentMethodData.account';
export const CP_ACCOUNT_TOKEN =
  'payway.currentPayment.currentWFS.paymentMethodData.cardsData.0.token';

export const LIST_GATEWAY_SUSC = 'payway.workflowStart.data.list';
export const LIST_GATEWAY_RENT =
  'payway.workflowStart.data.workflow.listBuyLinks';

export const TOKEN = 'user.token';
export const CURRENT_CONFIRMATION =
  'payway.currentPayment.currentPurchaseConfirmation';

export const USER_ID = 'user.user_id';
export const FIRST_NAME = 'user.firstname';
export const LAST_NAME = 'user.lastname';
export const EMAIL = 'user.email';

export const ICON_SUCCESS = 'asset.ticket_subscription_icon_confirm';
export const ICON_ERROR = 'asset.mail_modal_icon_warning';

export const IMG_MASTERCARD = '/webclient/sk_core/images/tdc_mastercard.png';
export const IMG_VISA = '/webclient/sk_core/images/tdc_visa.png';
